import * as React from 'react';
const SvgWeb = (props) => (
  <svg viewBox="0 0 138 138" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#web_svg__a)"
      stroke="#000"
      strokeWidth={3.6}
      strokeMiterlimit={10}
      strokeLinecap="round">
      <path d="M32.7 43.87c-7.112-2.35-13.658-5.64-19.483-10.115M116.267 38.557c-13.535 7.546-30.04 10.261-47.864 10.261-8.586 0-16.87-.62-24.657-2.11M94.216 91.54c-8.121-1.66-16.8-2.358-25.806-2.358-17.32 0-33.406 2.528-46.724 9.618M124.023 104.57c-5.678-4.421-12.069-7.725-18.995-10.106" />
      <path d="M73.15 135.803c36.892-2.295 64.939-34.063 62.644-70.956-2.295-36.892-34.063-64.939-70.956-62.643C27.945 4.498-.102 36.267 2.194 73.159c2.295 36.893 34.063 64.94 70.956 62.644Z" />
      <path d="M43.745 91.292c-.985-6.973-1.52-14.481-1.52-22.292C42.225 32.034 54.21 2.071 69 2.071c9.881 0 18.522 13.395 23.152 33.321M94.216 46.46c1.008 7.043 1.559 14.629 1.559 22.54 0 36.966-11.984 66.929-26.775 66.929-10.006 0-18.731-13.729-23.323-34.058" />
    </g>
    <defs>
      <clipPath id="web_svg__a">
        <path fill="#fff" d="M0 0h138v138H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWeb;
